import { LuX } from "react-icons/lu";
import styled from "@emotion/styled";
import { IconButton } from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import React, { memo, useCallback, useRef } from "react";
// Memoized Button Component
const CustomIconButton = styled(IconButton)`
  .MuiSvgIcon-root {
    color: ${({ tableBorder }) => tableBorder};
  }
`;
const SearchButton = ({ tableBorder, getSearchResult }) => {
  // console.log("search button rendered");
  return (
    <CustomIconButton
      size="small"
      tableBorder={tableBorder}
      onClick={getSearchResult}
    >
      <GridSearchIcon />
    </CustomIconButton>
  );
};

export default memo(SearchButton);
export function useSearchInputRef(externalRef) {
  const inputRef = useRef(null);
  const attachRef = useCallback(
    (input) => {
      inputRef.current = input;
      if (typeof externalRef === "function") externalRef(input);
      else if (externalRef) externalRef.current = input;
    },
    [externalRef]
  );
  return [inputRef, attachRef];
}

const ClearButton = styled("button")`
  && {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 28px;
    height: 28px;
    margin: 0;
    padding: 4px;
    border: 0;
    border-radius: var(--radius-sm, 4px);
    background: transparent;
    color: var(--text-tertiary);
    cursor: pointer;
  }

  &&:hover {
    background: var(--surface-secondary);
    color: var(--text-primary);
  }

  &&:focus-visible {
    outline: 2px solid var(--interactive-default);
    outline-offset: 2px;
  }

  && svg {
    width: 16px;
    height: 16px;
    margin: 0;
    color: currentColor;
  }
`;

export function SearchClearButton({ inputRef }) {
  const clear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const input = inputRef.current;
    if (!input || input.disabled || input.readOnly) return;
    const view = input.ownerDocument.defaultView;
    const setter = Object.getOwnPropertyDescriptor(
      view.HTMLInputElement.prototype,
      "value"
    ).set;
    // Use the native setter so React receives the existing input's change event.
    setter.call(input, "");
    input.dispatchEvent(new view.Event("input", { bubbles: true }));
    input.focus();
  };

  return (
    <ClearButton
      type="button"
      className="search-clear-button"
      aria-label="Clear search"
      title="Clear search"
      onMouseDown={(event) => event.preventDefault()}
      onClick={clear}
    >
      <LuX size={16} aria-hidden="true" />
    </ClearButton>
  );
}
